<template>
    <div class="div">Manonest</div>
</template>

<script>
export default {
    methods: {},
};
</script>